import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import { Button, Dialog, DialogActions, DialogTitle, DialogContent } from '@mui/material'
import Pagination from "react-js-pagination";
import mainPath from '../../utils/path';
import { TbLoader } from 'react-icons/tb';

const useStyles = makeStyles((theme)=>({
    itemRecommandBlock:{
        padding:'235px 0 0 0',

        fontFamily:[
        'Noto Sans KR'
        ],
        [theme.breakpoints.down(1025)]: {
            padding:'132px 0 0px 0',
        }
    },
    row:{
        maxWidth:'1200px', 
        margin:'0 auto', 
        padding:'70px 0 10px 0', 
    },
    itemRecommandBlockH1:{
        fontSize:'38px',
        textAlign:'center',
        letterSpacing: '-1.9px',
        paddingBottom:'60px',
        fontFamily:[
            'Noto Sans KR'
        ],
    },
    ShopMenuListTitleBlock:{
        height:'200px',
        maxWidth: 1902,
        margin: '0px auto',
        position:'relative',
        backgroundSize: '100% 200px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: 'url(/images/main_banner.png)',
        [theme.breakpoints.down(1025)]: {
            backgroundImage: 'url(/images/banner-6.png)',
        },
    },
    ShopMenuListH1:{
        fontSize:'38px',
        fontWeight:'500',
        letterSpacing: '-1.9px',
        paddingBottom:'10px',
        position:'absolute',
        top:'40%',
        left:'50%',
        transform:'translate( -50%, -50%)',
        fontFamily:[
            'Noto Sans KR'
        ],
        [theme.breakpoints.down(1025)]: {
            fontSize:'2rem',
        },
    },
    ShopMenuListSpan:{
        textAlign:'center',
        position:'absolute',
        top:'60%',
        left:'50%',
        transform:'translate( -50%, -50%)',
        fontFamily:[
            'Noto Sans KR'
        ],
        [theme.breakpoints.down(1025)]: {
            paddingTop: 10,
        },
    },
    boxDiv:{
        display:'flex',
        flexWrap:'wrap',
        justifyContent:'space-between',
        [theme.breakpoints.down(1124)]: {
            justifyContent:'center'
        },
    },
    article6flexDiv:{
        display:'flex',
        flexWrap:'wrap',
        marginBottom:'20px',
        cursor: 'pointer',
        borderRadius: 20,
        boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px',
        [theme.breakpoints.down(1025)]: {
            width:'180px', 
            height:'180px',
            margin: 10
        },
    },
    recoImg:{
        width:'180px', 
        height:'180px',
        borderRadius: '20px 0 0 20px',
        [theme.breakpoints.down(1025)]: {
            borderRadius: '20px',
        },     
    },
    spanDiv:{
        background:'#FFF1E4',
        width:'370px',
        position:'relative',
        color:'#232323',
        letterSpacing: '-1px',
        borderRadius: '0 20px 20px 0',
        fontFamily:[
            'Noto Sans KR'
        ],
        [theme.breakpoints.down(1025)]: {
            display: 'none'
            
        },
    },
    content:{
        padding:'10px'
    },
    date:{
        position:'absolute',
        right:'0',
        bottom:'0',
        padding:'10px',
        fontFamily:[
            'Noto Sans KR'
        ],
        [theme.breakpoints.down(1025)]: {
            //display: 'none',   
        },
    },
    innerClass: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '75px',
        listStyle: 'none',
        padding: 0,
    },
    itemClass: {
        display: 'inline-block',
        width: '36px',
        height: '30px',
        border: '1px solid #DDDDDD',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '1rem',
    },
    itemClassFirst: {
    },
    itemClassLast: {
    },
    linkClass: {
        fontSize: '0.8rem',
    },
    activeClass: {
        backgroundColor: '#007235'
    },
    activeLinkClass: {
        color: 'white',
    },
    load:{
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
    },
    loadingIcon:{
        color:'#007235',
        fontSize:'50px',
        animation:'$loadSpin 5s infinite',
        position:'absolute',
        top:'60%',
        left:'50%',
        transform:'translate(-50%, -50%)'
    },
    "@keyframes loadSpin":{
        from: { transform:'rotate(0deg)' },
        to: { transform:'rotate(1turn)' }
    },
    modalTextarea:{
        margin:'10px 0',
        padding:'5px',
        width:'100%',
        height:'80px',
        borderRadius:'5px',
        background:'#FFF1E4',
        border:'2px solid #007235', 

        fontFamily:[
            'Noto Sans KR'
        ],
    },
    
    modalDate:{
        float:'right',
        fontFamily:[
            'Noto Sans KR'
        ],
    },
}));

const ItemRecommand = () => {
    const theme = useTheme();
    const classes = useStyles(theme);
    const [page, setPage] = useState(1);
    const [pasings, setPasings] = useState(0);
    const [data, setData] = useState([])
    const [dialog, setDialog] = useState('');

    const [pickData, setPickData] = useState()

    const [loading, setLoading] = useState(false)

    const getItems = async() => {
        try {
            setLoading(true)
            const res = await axios.post('/api/shop/getRecomands/', {page: page})
            if(res.data.success === false) {
                setDialog('불러오기 실패')
                setLoading(false)
                return;
            }

            const resData = res.data.result

            setData(resData)
            setPasings(res.data.itemCount)
            setLoading(false)

        } catch (e) {
            setLoading(false)
            console.log(e)
        }
    }
    useEffect( () => {
        getItems()
        window.scrollTo(0, 0);
    }, [page])

    useEffect(() => {

        return () => {
          setData([])
        }
      }, [])

    const handlePageChange = (page) => {
        setPage(page);
    };


  return (
    <div className={classes.itemRecommandBlock}>
        <div 
            className={classes.ShopMenuListTitleBlock} 
        >
            <h1 className={classes.ShopMenuListH1}>팀장님 추천</h1>
            <span className={classes.ShopMenuListSpan}>
                생초플라워의 꽃 전문가들이 선택한 가장 신선한 꽃
            </span>
        </div>
        <div className={classes.row}>
            <div className={classes.boxDiv}>
                {loading ? (
                <div className={classes.load}>
                    <TbLoader className={classes.loadingIcon}/>
                </div>
                ) :
                data.length > 0 && data.map((result, idx) => {
    
                    return ( 
                            <div 
                                className={classes.article6flexDiv}
                                onClick={() => {
                                    setPickData(result)
                                }}
                                key={idx}
                            >
                                <img 
                                    src={`${mainPath}/media/data/recomand/${result['reco_img']}`}  
                                    alt='' 
                                    className={classes.recoImg}
                                />
                                <div className={classes.spanDiv}>
                                    <div className={classes.content}>
                                        <span>
                                            {result['reco_cont']}
                                        </span>
                                    </div>
                                    <div className={classes.date}>
                                        <span>
                                            {result['reco_date']}
                                        </span>
                                    </div>
                                </div>                            
                            </div>      
                    )
                }
                )}
            </div>
        </div>
        



      <Pagination
            activePage={page}
            itemsCountPerPage={10}
            totalItemsCount={pasings}
            pageRangeDisplayed={5}
            prevPageText={"‹"}
            nextPageText={"›"}
            onChange={handlePageChange}
            className={classes.navi}
            innerClass={classes.innerClass}    //안에?
            itemClass={classes.itemClass}      //아이템들?
            itemClassFirst={classes.itemClassFirst}    //first?
            itemClassLast={classes.itemClassLast}     // last
            linkClass={classes.linkClass}        // 아이템 링크
            activeClass={classes.activeClass}        // 현재페이지
            activeLinkClass={classes.activeLinkClass}     // 현제페이지 링크
        />

        <Dialog
            open={dialog === '' ? false : true}
            onClose={() => setDialog('')}
        >
            <DialogTitle id="alert-dialog-title">
                {dialog}
            </DialogTitle>
            <DialogActions>
                <Button 
                    onClick={() => setDialog('')} 
                    autoFocus
                    
                >
                    확인
                </Button>
            </DialogActions>
        </Dialog>

        <Dialog
            open={pickData ? true : false}
            onClose={() => setPickData()}
        >
            <DialogContent>
                {pickData && (
                    <>
                    <img 
                        src={`${mainPath}/media/data/recomand/${pickData['reco_img']}`} 
                        style={{width: 1000}} 
                    />
                    <textarea 
                        value={pickData['reco_cont']} 
                        readonly 
                        className={classes.modalTextarea}
                    />
                    <div className={classes.modalDate}>{pickData['reco_date']}</div>
                    </>
                )}
            </DialogContent>
            <DialogActions style={{ display:'flex', justifyContent:'center'}}>
                <Button 
                    onClick={() => setPickData()}
                    style={{ 
                        background:'#007235', 
                        color:'#fff',
                        fontFamily:[
                            'Noto Sans KR'
                        ],
                    }}
                > 
                    확인 
                </Button>
            </DialogActions>
        </Dialog>
    </div>
  )
}

export default ItemRecommand
